export const PhotoUploadState = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  SENT: 'SENT',
  ERROR: 'ERROR',
};
